import * as firebase from "firebase/app";
import "firebase/auth";
import request from "request";

const firebaseConfig = {
  apiKey: "AIzaSyDrDLG3-t8dN66T6huGd2SPWrDtsso4hzQ",
  authDomain: "dww-web-52b3e.firebaseapp.com",
  databaseURL: "https://dww-web-52b3e.firebaseio.com",
  projectId: "dww-web-52b3e",
  storageBucket: "",
  messagingSenderId: "267167280403",
  appId: "1:267167280403:web:c55a33fd9161565df67ee6",
  measurementId: "G-KJ44JBS0PN",
};

let baseApiUrl;
// process.env.NODE_ENV === "development"
//   ? "http://localhost:3005/dev"
//   : "https://1bsdoamdrl.execute-api.us-east-1.amazonaws.com/dev";

if (process.env.NODE_ENV === "development") {
  if (document.URL.startsWith("https")) {
    baseApiUrl = "https://localhost:3005/dev";
  } else {
    baseApiUrl = "http://localhost:3005/dev";
  }
  //apiUrl = "https://xhzhz9l540.execute-api.us-east-1.amazonaws.com/staging";
} else if (
  window &&
  (window.location.href.startsWith("https://beta.") ||
    window.location.href.startsWith("https://beta--") ||
    window.location.href.startsWith("https://deploy-preview-"))
) {
  baseApiUrl = "https://drjgvktzo5.execute-api.us-east-1.amazonaws.com/beta";
} else {
  baseApiUrl = "https://2mcdy6nhn9.execute-api.us-east-1.amazonaws.com/prod";
}

export const apiUrl = baseApiUrl;

export const companies = {
  changedotorg: "Change.org",
  hungryroot: "Hungryroot",
  prospect: "Prospective Clients",
  hok: "HoK",
  candid: "Candid",
  teacherspayteachers: "Teachers Pay Teachers",
  demo: "Demo",
  test: "Testing",
  cookunity: "CookUnity",
  all: "All Tests",
  dailyharvest: "Daily Harvest",
  variis: "Variis",
};
export const loginLookup = {
  changedotorg: "22484273-b6ea-4612-aa69-68126c88599e",
  hungryroot_old: "a945451a-367c-4924-9d55-6b56700ddf97",
  hungryroot: "5a003a1c-0bef-495a-b8a8-6c4d98b9c1bd",
  demo: "6a65e917-b1eb-4607-b7b6-f3fd26bf5377",
  hok: "f453c0fc-29e7-438c-b402-da50b801c67d",
  candid: "dad304f1-948c-43db-9caa-9d10413a47e0",
  teacherspayteachers: "a62bc59e-3c46-4d50-844e-b6b386733db8",
  prospect: "cf6e66f0-25c3-4453-8568-9ecd029315ce",
  disney: "33a30a88-f75a-4a65-b5c7-83ff958ff002",
  purplecarrot: "efa1acf2-1ee4-462a-8591-8973ebafa34d",
  cookunity: "ee16bd44-3a8b-4911-83b3-df398c69d432",
  test: "8b4f525e-b33f-47a9-bbbf-0ac392e36367",
  admin: "admin",
  variis: "8067a95b-7e8e-4a31-a796-ae0c2e6bce07",
  all: "a1bc8b23-3724-45a0-b387-2013475f512d",
  pillclub: "4e27dc09-ad3c-4b1b-a122-3147b2c40766",
  dailyharvest: "91e18338-ec36-487f-ade3-27f2ce497f7b",
  alexgodin: "ca5720a6-2355-4ecc-b189-9cb329fd6093",
  veestro: "39c5bd00-0ec8-4e1f-bb49-7124b36054ef",
  allplants: "e1559f52-0143-49a0-aa8b-e8a17b8d29e9",
  phin: "b49bf677-2475-4027-a11d-8d44b9f939e9",
  mirror: "f3616bbd-24dd-4d4c-adbb-18b8c259bdc6",
  homechef: "9c57b974-ee2d-44e9-b91a-c236a2b17dd3",
  cbs: "97242189-c3a8-4ce2-b2e7-1a7ede52b285",
  curology: "2850cb5a-f011-43db-9da9-ecb8635caee9",
  hellofresh: "a80162c6-2c2c-40b0-9f61-e4026bbbe929",
  duolingo: "a9cee209-2309-4349-b572-268afe7adc13",
  edlyn: "f073419f-cb11-437a-be19-5cd077d47488",
  siriusxm: "1ed0e233-d8fe-4cce-a232-6cb4be3c1285",
  spotify: "b125e14a-6c6b-458d-88e5-e10e11392655",
  disneydemo: "635ea9c9-15f6-40bf-8625-3477c268571d",
  vidsense: "ee43ef5b-dc7e-4fd0-bc3b-a5f028b0b4f3",
  steveberry: "c9d9544f-f64c-4470-b3c3-3f452761653d",
  lovevery: "c2bc26db-4b22-4e09-998f-15e1b9263bc9",
  peacock: "afb131cf-84e3-44b1-9d3c-5dead5daf867",
  marleyspoon: "599b5861-6f76-4cf8-a009-22a7dd2a811a",
  classpass: "34d74a1e-57ea-475d-a1bf-2978742c91a2",
  buildbook: "97d26982-0bd2-4ded-9b45-614b2522c0d7",
  dashboard: "d5b215ce-efed-4ea4-b7ee-aec4e680081b",
  webex: "xx",
};
const rLookup = {};
export const companyNames = {
  changedotorg: "Change.org",
  hungryroot: "Hungryroot",
  demo: "Demo",
  hok: "HoK",
  candid: "Candid",
  teacherspayteachers: "Teachers Pay Teachers",
  prospect: "Prospect",
  disney: "Disney+",
  disneydemo: "Disney+",
  purplecarrot: "Purple Carrot",
  cookunity: "CookUnity",
  test: "Test",
  variis: "Variis",
  admin: "Admin",
  pillclub: "Pill Club",
  alexgodin: "Alex Godin",
  dailyharvest: "Daily Harvest",
  allplants: "allplants",
  phin: "Phin",
  veestro: "Veestro",
  mirror: "Mirror",
  homechef: "Home Chef",
  hellofresh: "HelloFresh",
  duolingo: "Duolingo",
  edlyn: "Edlyn",
  cbs: "CBS Interactive",
  curology: "Curology",
  all: "All Tests",
  siriusxm: "SiriusXM",
  spotify: "Spotify",
  vidsense: "Vidsense",
  steveberry: "Steve Berry",
  lovevery: "Lovevery",
  peacock: "Peacock",
  marleyspoon: "Marley Spoon",
  classpass: "ClassPass",
  buildbook: "BuildBook",
  charitywater: "Charity: Water",
  dashboard: "Sample",
};

Object.keys(loginLookup).forEach(c => {
  rLookup[loginLookup[c]] = {
    key: c,
    name: companyNames[c],
  };
});
export const reportLookup = (report, comma) => {
  if (rLookup[report]) {
    return `${comma ? ", " : ""}${rLookup[report].name}`;
  } else if (report === "8856d019-8c3e-489d-b0aa-32bd0923c6a0") {
    return `${comma ? ", All tests draft" : "All tests draft"}`;
  } else {
    return `${comma ? ", Prospect" : "Prospect"}`;
  }
};
export const moduleLookup = {
  "Driving trial & adoption": "Driving trial & adoption",
  "Optimizing plans & pricing page": "Pricing & plans",
  "Testing offers & promotions": "Offers & promotions",
  "Search messaging & landing pages": "Search messaging",
  "Seller / host / supplier acquisition": "Supplier acquisition (marketplaces)",
  "Driving donations": "Driving donations",
};

export const getCompanyName = company => {
  return companies[company] || "Unknown";
};

firebase.initializeApp(firebaseConfig);

export const fbAuth = firebase.auth();

export const truncateText = (text, amount = 25) => {
  if (text.length <= amount) {
    return text;
  }
  return `${text.substring(0, amount)}...`;
};

const padZero = num => {
  if (num >= 10) {
    return num;
  } else {
    return `0${num}`;
  }
};
export const formatTime = isoDate => {
  const date = new Date(isoDate);
  return `${padZero(date.getHours())}:${padZero(date.getMinutes())}`;
};

export const formatDate = isoDate => {
  const date = new Date(isoDate);
  return `${
    date.getUTCMonth() + 1
  }/${date.getUTCDate()}/${date.getUTCFullYear()}`;
};

export const getWeek = date => {
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return (
    1 +
    Math.round(
      ((date.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    )
  );
};

const cache = {};

const CACHE_TIME = 1800000;

export const getData = url =>
  new Promise((resolve, reject) => {
    const cachedData = cache[url];
    const now = new Date().getTime();

    if (cachedData && cachedData.ttl - now <= CACHE_TIME) {
      console.info("cache hit!");
      resolve(cachedData.data);
      return;
    }
    request(url, (err, res, data) => {
      if (err) {
        reject(err);
        return;
      }
      const json = JSON.parse(data);
      cache[url] = {
        data: json,
        ttl: new Date().getTime(),
      };
      resolve(json);
    });
  });
export const imageUrl = (url, width, height, modifier = 2) => {
  let newUrl = "";
  if (typeof url === "string") {
    newUrl = url.replace(
      "https://dwwwww.s3.amazonaws.com",
      `https://d39sdekjh6lrma.cloudfront.net/${width * modifier}x${
        height * modifier
      }`
    );
  } else if (url && url[0]) {
    newUrl = url[0].replace(
      "https://dwwwww.s3.amazonaws.com",
      `https://d39sdekjh6lrma.cloudfront.net/${width * modifier}x${
        height * modifier
      }`
    );
  }
  return newUrl;
};

export const capitalize = str =>
  str ? `${str.charAt(0).toUpperCase()}${str.slice(1)}` : "";

export const formatReportDate = dateStr => {
  const date = new Date(dateStr);
  date.setUTCHours(18);
  return formatDate(date);
};
export const getDurationToGivenDate = givenDate => {
  // Create Date objects for today and the given date
  var today = new Date();
  var endDate = new Date(givenDate);

  // Calculate the difference in milliseconds
  var timeDifference = endDate.getTime() - today.getTime();

  // Convert milliseconds to days
  var daysDifference = timeDifference / (1000 * 3600 * 24);

  // Return the duration in days
  return Math.round(daysDifference);
};

export const formatDateAndTime = date => {
  return `${formatDate(date)} ${formatTime(date)}`;
};
export const formatDateAndTimeFromString = dateStr => {
  const date = new Date(dateStr);
  return formatDateAndTime(date);
};
